import { render } from "./updateChargeGroup.vue?vue&type=template&id=01969dc6&scoped=true"
import script from "./updateChargeGroup.vue?vue&type=script&lang=js"
export * from "./updateChargeGroup.vue?vue&type=script&lang=js"

import "./updateChargeGroup.vue?vue&type=style&index=0&id=01969dc6&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01969dc6"]])

export default __exports__